/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSyncEntities} from '../api'

 export const useQueryGetSyncEntities = createReactQueryHook('getSyncEntities', getSyncEntities)
